import { useState } from 'react';
import { toast } from 'sonner';
import { ShieldAlert } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { useAuth } from '../../context/AuthContext';
import { api, errMsg } from './api';

const ELIGIBLE = ['valide', 'lie_existant', 'justificatif_seul', 'justificatif_doublon'];
const ROLES = ['super_admin', 'admin', 'admin_agence'];

// Correction contrôlée d'une facture déjà comptabilisée : contre-écriture tracée, jamais de modification de la dépense d'origine
export function CorrectionBox({ d, onDone }) {
    const { user } = useAuth();
    const [plan, setPlan] = useState(null);
    const [motif, setMotif] = useState('');
    const [busy, setBusy] = useState(false);
    if (!ELIGIBLE.includes(d.statut) || !ROLES.includes(user?.role) || (d.affectation?.type && d.statut === 'valide')) return null;
    const open = async () => { try { setPlan(await api.correction(d.id, { simulation: true })); } catch (e) { toast.error(errMsg(e)); } };
    const go = async () => {
        setBusy(true);
        try { await api.correction(d.id, { motif }); toast.success('Correction enregistrée et tracée — facture remise en attente pour réattribution'); setPlan(null); onDone(); }
        catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
    };
    if (!plan) return <Button variant="outline" size="sm" onClick={open} className="text-[12px]" data-testid="invoice-correction-open"><ShieldAlert className="w-4 h-4 mr-1.5" />Corriger l'attribution (gérant / administrateur)</Button>;
    return (
        <div className="rounded-xl border border-amber-300 bg-amber-50 p-3 space-y-2" data-testid="invoice-correction-box">
            <p className="text-[12px] font-medium text-amber-900">Correction contrôlée{plan.vehicule ? ` — ${plan.vehicule}` : ''}</p>
            <p className="text-[12px] text-amber-900" data-testid="invoice-correction-plan">{plan.message}</p>
            <Textarea value={motif} onChange={e => setMotif(e.target.value)} placeholder="Motif de la correction (obligatoire)" className="text-[12px] min-h-[52px] bg-white" data-testid="invoice-correction-motif" />
            <div className="flex gap-2">
                <Button size="sm" variant="outline" onClick={() => setPlan(null)} data-testid="invoice-correction-cancel">Annuler</Button>
                <Button size="sm" disabled={busy || motif.trim().length < 3} onClick={go} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="invoice-correction-submit">Enregistrer la correction</Button>
            </div>
        </div>
    );
}
